// extracted by mini-css-extract-plugin
module.exports = {"mailing_list":"styles_mailing_list__O_AY2","headingText":"styles_headingText__IeJJb","buttonStyle":"styles_buttonStyle__r2EU9"};